import { jsx } from "react/jsx-runtime";
import { F as FooterDisclosure } from "./FooterDisclosure-BZMcCqlo.js";
const InAppMessagesDisclosureApp = () => {
  return /* @__PURE__ */ jsx(FooterDisclosure, {});
};
export {
  InAppMessagesDisclosureApp,
  InAppMessagesDisclosureApp as default
};
//# sourceMappingURL=InAppMessagesDisclosureApp-DYBOiVtm.js.map
